import _sfc_main from "/vercel/path0/src/App.vue?vue&type=script&setup=true&lang.ts";
export * from "/vercel/path0/src/App.vue?vue&type=script&setup=true&lang.ts";
export default _sfc_main;
